/**
 * The forms step: the studio's required forms, one at a time, each with its
 * name and kind, the dots and "N of M forms", and Continue (Continue to
 * payment on the last when payment follows).
 */
import { definePiece } from '../../contract/define';

export const contract = definePiece({
  name: 'forms-step',
  description: "The studio's required forms in the checkout, one at a time, with the count of forms and Continue.",
  options: {},
  parts: {
    back: { description: 'Back to the form before, or to the offering from the first.', required: false, states: ['disabled'] },
    title: { description: "The form's name.", required: true, role: 'title' },
    kind: { description: "The form's kind: Intake form · Required to book, Waiver · Required to sign.", required: false },
    count: { description: 'The dots and "N of M forms", when the client owes two or more.', required: false },
    description: { description: "The form's description, when the studio wrote one.", required: false },
    fields: { description: "The form's fields.", required: true },
    submit: { description: 'Continue, or Continue to payment on the last form.', required: true, states: ['disabled'], role: 'primary-action' },
    submitError: { description: 'The line above the button when the answers could not be sent and no field says why.', required: false },
    failed: { description: "A form that could not be read, in the app's words, with Go Back.", required: true },
  },
  actions: {
    back: { description: 'Goes back to the form before, or to the offering from the first form.', args: [] },
  },
  events: {
    formSubmitted: "The client sent one of the studio's forms.",
  },
});

/** What the forms step knows. */
export interface FormsStepState {
  /** loading until the form is read; failed when it could not be. */
  readonly status: 'loading' | 'ready' | 'failed';
  /** 1-based place of this form among all the client owes (registration counted). */
  readonly index: number;
  /** How many forms the client owes in all. */
  readonly total: number;
}

/** What a drawing can ask the forms step to do. */
export interface FormsStepActions {
  /** Go back to the form before, or to the offering from the first form. */
  readonly back: () => void;
}

/** What the forms step tells its host. */
export interface FormsStepEvents {
  /** The client sent one of the studio's forms. */
  readonly formSubmitted: { readonly index: number };
}
